import { TFunction } from "i18next";
import { z } from "zod";

import { Roles } from "src/core/constants/roles";
import {
  contactInformationSchema,
  defaultContactInformationValues,
} from "src/core/forms/create-client/contactInformations.schema";
import {
  createClientCommonSchema,
  defaultCreateClientCommonValues,
} from "src/core/forms/create-client/createClientCommon.schema";
import { dateOfBirthRule, nameRule } from "src/core/forms/validators/rules";
import { User } from "src/core/gql/graphql";

export const createClientEISchema = (t: TFunction, showContactInfo = false) =>
  contactInformationSchema(t, showContactInfo)
    .merge(createClientCommonSchema)
    .extend({
      prenomEI: nameRule(t, { checkIfShown: true, required: true }),
      nomEI: nameRule(t, { checkIfShown: true, required: true }),
      dateDeNaissanceEI: dateOfBirthRule(t, { checkIfShown: true, required: true }),
    });

export type CreateClientEIFormValues = z.infer<ReturnType<typeof createClientEISchema>>;

export const defaultCreateClientEIValues = (
  user: User,
  hasRole: (role: Roles) => boolean
): CreateClientEIFormValues => {
  return {
    ...defaultContactInformationValues(),
    ...defaultCreateClientCommonValues(user, hasRole),
    prenomEI: "",
    nomEI: "",
    dateDeNaissanceEI: "",
  };
};
